import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription, fromEvent } from 'rxjs';
import { startWith } from 'rxjs';
import { AppLoginService } from '../app-login.service';
import { environment } from '@env/environment';
import { RegistrationService } from '@app/registration/registration.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-find-your-account',
  templateUrl: './find-your-account.component.html',
  styleUrls: ['./find-your-account.component.scss']
})
export class FindYourAccountComponent implements OnInit, OnDestroy {
  findaccount: FormGroup;
  isSubmitted = false;
  emailSent = false;
  isMobile = false;
  logoPath = 'assets/images/edu-logo.svg';
  resizeObservable$: Subscription | undefined;
  isButtonDisabled = true; // Button starts disabled
  isSubmitting = false;
  @Input() mode: 'forgot' | '2fa' = 'forgot';
  @Input() email: string | null = null;
  @Input() phone: string | null = null;
  constructor(private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly appLoginService: AppLoginService,
    private readonly registrationService: RegistrationService,
    private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
        this.findaccount = this.fb.group({
      method: ['email']
    });
    this.route.queryParams.subscribe(params => {
    // Set from query params if present, otherwise keep defaults
    this.mode = params['mode'] || this.mode;
    this.email = params['email'] || this.email;
    this.phone = params['phone'] || this.phone;

    if (this.mode === '2fa') {
      if (this.email) {
        this.findaccount.patchValue({ method: 'email' });
      } else if (this.phone) {
        this.findaccount.patchValue({ method: 'phone' });
      }
    }
  });
  }

      send2faOtp(): void {
    const selectedMethod = this.findaccount.get('method').value;
    if (selectedMethod === 'email' && this.email) {
      const request = { email: this.email };
      this.registrationService.sendPrimaryEmailOtp(request).subscribe({
        next: () => {
          this.router.navigate(['/verify-forgot-password'], { queryParams: { mode: '2fa', method: 'email', email: this.email } });
        },
        error: error => {
          // Handle error (show message, etc.)
        }
      });
    } else if (selectedMethod === 'phone' && this.phone) {
      // If you have a phone OTP API, call it here. Otherwise, just navigate:
      this.router.navigate(['/verify-forgot-password'], { queryParams: { mode: '2fa', method: 'phone', phone: this.phone } });
    }
  }

   onContinue(): void {
    const selectedMethod = this.findaccount.get('method').value;
    if (selectedMethod === 'email') {
      this.router.navigate(['/forgot-password-email']);
    } else if (selectedMethod === 'phone') {
      this.router.navigate(['/forgot-password-phone']);
    }
  }
  onCancel(): void {
  this.router.navigate(['/login']);
}
  
  ngOnDestroy(): void {
    if (this.resizeObservable$) {
      this.resizeObservable$.unsubscribe();
    }
  }
  
  
  updateLogoPath(): void {
    this.logoPath = this.isMobile 
      ? 'assets/images/cardy-ai/mobile-logo.svg'
      : 'assets/images/edu-logo.svg';
  }
  get formControls() {
    return this.findaccount.controls;
  }

maskEmail(email: string): string {
  if (!email) return '';
  const [local, domain] = email.split('@');
  if (local.length < 2) return email; // Not enough to mask

  // Show first letter, mask middle, show last letter before @
  const first = local[0];
  const last = local[local.length - 1];
  const masked = local.length > 2 ? '*'.repeat(local.length - 2) : '';
  return `${first}${masked}${last}@${domain}`;
}

maskPhone(phone: string): string {
  // Remove non-digits
  const digits = phone.replace(/\D/g, '');
  if (digits.length < 10) return phone;
  // Mask area code and next three digits: (xxx)xxx-1234
  return `(xxx)xxx-${digits.slice(-4)}`;
}
}
